import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'obc-modal-botao-unico',
  templateUrl: './modal-botao-unico.component.html',
  styleUrls: ['./modal-botao-unico.component.scss'],
})
export class ModalBotaoUnicoComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { titulo: string; mensagem: string; textoBtnPrimario: string; isBtnFechar: boolean },
    private bottomSheetRef: MatBottomSheetRef<ModalBotaoUnicoComponent>
  ) {}

  ngOnInit(): void {}

  fecharModal() {
    this.bottomSheetRef.dismiss(false);
  }

  confirmarModal() {
    this.bottomSheetRef.dismiss(true);
  }
}
